import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgUpdates = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path fill={_.color} d="M3 6h2.143v7H3zm4-3h2v10H7zm4 5.714h2V13h-2z" />
  </svg>
);
const ForwardRef = forwardRef(SvgUpdates);
export default ForwardRef;
